<template>
    <div class="relative h-screen-index">
        <div class="flex flex-wrap">
            <div ref="file-section"
                class="w-full md:w-96 bg-base-100 shadow-xl rounded-xl md:my-2 md:ml-2 h-screen-header-tree">
                <file-tree ref="file-tree"></file-tree>
            </div>
            <div class="resize-handle" :class="{ resizing: isResizing }" @mousedown="startResize"></div>
            <div ref="edit-section" class="edit-section bg-base-100 shadow-xl rounded-xl !hidden md:!block">
                <transition name="slide-fade">
                    <div class="flex">
                        <batch-action></batch-action>
                    </div>
                </transition>
            </div>
            <div ref="resource-section" class="resource-section bg-base-100 shadow-xl rounded-xl !hidden md:!block">
                <!-- <transition name="slide-fade" v-if="!isShowResourceId3">
                    <resource v-show="fadeShowDetail" :song-list="SongList" :section3-loading="section3Loading">
                    </resource>
                </transition> -->
                <transition name="slide-fade">
                    <div>
                        <div v-if="showId3ListLoading" class="flex justify-center">
                            <span class="loading loading-infinity loading-lg"></span>
                        </div>
                        <multi-meta-data
                            v-show="showId3List"
                            :file-id3-list="fileID3List"
                            :files-number="filesNumber"
                            :folder-number="folderNumber"
                            :has-more="hasMoreData"
                            :is-loading="isLoadingMore"
                            @load-more="handleLoadMore"
                            @page-size-change="handlePageSizeChange">
                        </multi-meta-data>
                    </div>
                </transition>
                <div v-show="!fadeShowDetail && !showTranslation && !isShowResourceId3 && !showId3List"
                    style="width: 90%;height: 90%; margin: 50px 20px 20px 50px;">
                    <img v-if="!isHiddenBGP" src="/static/dist/img/music_null-cutout.png"
                        class="w-full h-[98%] object-contain" />
                </div>
            </div>
            <!-- 元数据详情 -->
            <div class="drawer">
                <input id="edit" type="checkbox" class="drawer-toggle" v-model="isShowEdit2" />
                <div class="drawer-side">
                    <label for="edit" aria-label="close sidebar" class="drawer-overlay"></label>
                    <div class="p-4 pb-20 md:pb-4 min-h-full bg-base-100 text-base-content w-full md:w-96 pb-20 md:pb-4">
                        <div class="flex justify-between items-center mb-4">
                            <div class="text-xl font-medium">元数据详情</div>
                            <div>
                                <button class="btn btn-sm" @click="isShowEdit2 = false">
                                    x
                                </button>
                            </div>
                        </div>
                        <div>
                            <music-meta-data v-show="isShowEdit2" :loading='section2Loading' :music-info="musicInfo"
                                :reload-img="reloadImg" :drawer-mode="'drawer'"
                                @show-version-history="handleShowVersionHistory">
                            </music-meta-data>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 资源详情 -->
            <div class="drawer drawer-end">
                <input id="resource-id3" type="checkbox" class="drawer-toggle" v-model="isShowResourceId3" />
                <div class="drawer-side">
                    <label for="resource-id3" aria-label="close sidebar" class="drawer-overlay"></label>
                    <div class="p-4 min-h-full bg-base-100 text-base-content w-80 md:w-[800px]">
                        <resource :song-list="SongList" :section3-loading="section3Loading"></resource>
                    </div>
                </div>
            </div>
            <!-- 歌词翻译 -->
            <div class="drawer drawer-end">
                <input id="trans-lrc" type="checkbox" class="drawer-toggle" v-model="showTranslation" />
                <div class="drawer-side">
                    <label for="trans-lrc" aria-label="close sidebar" class="drawer-overlay"></label>
                    <div class="p-4 min-h-full bg-base-100 text-base-content w-80 md:w-[800px]">
                        <div style="display: flex;height: 100%;">
                            <button class="btn btn-xs mt-4" @click="handleCopy('lyric_tran', translationText)">
                                <svg-icon name="left-arrow" class="icon w-6 h-6" />
                            </button>
                            <div style="width: 100%;height: 100%;">
                                <textarea placeholder="" v-model="translationText"
                                    class="mt-4 textarea textarea-bordered textarea-xs w-full h-screen-header">
                                </textarea>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 歌词时间轴 -->
            <div class="drawer drawer-end">
                <input id="lyrics-timeline" type="checkbox" class="drawer-toggle" v-model="showLyricsTimeline" />
                <div class="drawer-side">
                    <label for="lyrics-timeline" aria-label="close sidebar" class="drawer-overlay"></label>
                    <div class="p-4 min-h-full bg-base-100 text-base-content w-full max-w-7xl">
                        <div class="flex justify-between items-center mb-4">
                            <div class="text-xl font-medium"></div>
                            <button class="btn btn-sm btn-ghost" @click="showLyricsTimeline = false">
                                <svg class="w-4 h-4 fill-current" viewBox="0 0 24 24">
                                    <path
                                        d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
                                </svg>
                            </button>
                        </div>
                        <lyrics-timeline :play-path="playPath" :raw-lyrics="rawLyrics" @saveLyrics="handleSaveLyrics" />
                    </div>
                </div>
            </div>
            <!-- 版本历史 -->
            <div class="drawer drawer-end">
                <input id="version-history" type="checkbox" class="drawer-toggle" v-model="showVersionHistory" />
                <div class="drawer-side">
                    <label for="version-history" aria-label="close sidebar" class="drawer-overlay"></label>
                    <div class="min-h-full bg-base-100 text-base-content w-full md:w-[900px]">
                        <!-- 抽屉头部 -->
                        <div class="sticky top-0 bg-base-100 z-10 border-b border-base-300 px-6 py-4">
                            <div class="flex justify-between items-center">
                                <div class="flex items-center gap-3">
                                    <svg class="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                                    </svg>
                                    <h3 class="font-bold text-xl">元数据版本历史</h3>
                                </div>
                                <button class="btn btn-sm btn-circle btn-ghost" @click="showVersionHistory = false">✕</button>
                            </div>
                            <!-- 音轨信息 -->
                            <div v-if="versionTrackInfo && versionTrackInfo.title" class="mt-3 p-3 bg-base-200/50 rounded-lg">
                                <div class="flex items-center gap-2">
                                    <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19V6l12-3v13M9 19c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zm12-3c0 1.105-1.343 2-3 2s-3-.895-3-2 1.343-2 3-2 3 .895 3 2zM9 10l12-3"></path>
                                    </svg>
                                    <div class="flex-1 min-w-0">
                                        <div class="font-semibold truncate">{{ versionTrackInfo.title }}</div>
                                        <div class="text-sm opacity-70 truncate">{{ versionTrackInfo.path }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- 抽屉内容 -->
                        <div class="p-6 overflow-y-auto" style="height: calc(100vh - 200px);">
                            <MetadataVersionHistory
                                ref="versionHistoryComponent"
                                @restored="handleVersionRestored"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import FileTree from './fileTree'
import MusicMetaData from './musicMetaData'
import BatchAction from './batchAction'
import Resource from './resource'
import MultiMetaData from './multiMetaData'
import LyricsTimeline from './lyricsTimeline'
import MetadataVersionHistory from './MetadataVersionHistory.vue'
import { mapGetters, mapState } from 'vuex'
import SvgIcon from '@/components/SvgIcon.vue'
export default {
    components: {
        MusicMetaData,
        FileTree,
        BatchAction,
        Resource,
        MultiMetaData,
        LyricsTimeline,
        MetadataVersionHistory,
        SvgIcon
    },
    data() {
        return {
            theme: document.documentElement.getAttribute('data-theme'),
            fullPath: '',
            fileName: '',
            resource: localStorage.getItem('resource') ? localStorage.getItem('resource') : 'netease',
            translationText: '',
            baseMusicInfo: {},
            isSaveLyricsFile: false,
            isSaveAlbumCover: false,
            isImportLyricsFile: false,
            genreInputList: [],
            languageInputList: [],
            albumArtistInputList: [],
            musicInfo: {
            },
            musicInfoManual: {},
            fadeShowDir: false,
            showId3List: false,
            showId3ListLoading: false,
            isLoading: false,
            SongList: [],
            reloadImg: true,
            test: true,
            isSkipTag: true,
            isFolderAlbum: false,
            albumArtistList: [],
            isShowEdit: false,
            isShowEdit2: false,
            selectAutoMode: 'normal',
            sourceList: [],
            fileID3List: [],
            fileID3ListCopy: [],
            // 分页相关数据
            currentPage: 1,
            pageSize: parseInt(localStorage.getItem('pageSize')) || 50,
            totalCount: 0,
            hasMoreData: false,
            isLoadingMore: false,
            lastRequestParams: null,
            modifyList: ['artist', 'album', 'album_img', 'year', 'lyrics'],
            modifyListL: ['title', 'artist', 'album'],
            relaceTextList: [],
            tidyFormData: {
                root_path: '/app/media/',
                dir_list: [{ 'value': 'artist' }, { 'value': 'album' }]
            },
            isOpenDetail: localStorage.getItem('isOpenDetail') ? localStorage.getItem('isOpenDetail') : true,
            batchSettingFormData: {
                'isOpenDetail': localStorage.getItem('isOpenDetail') !== 'false',
                'isDepth': localStorage.getItem('isDepth') === 'true',
                'limit': localStorage.getItem('limit') ? localStorage.getItem('limit') : 100
            },
            sortedListOrder: ['forward', 'reverse'],
            nowSortedOrder: 'none',
            nowSortedKey: '',
            isShowResourceId3: false,
            fadeShowDetail: false,
            showTranslation: false,
            showLyricsTimeline: false,
            section3Loading: false,
            section2Loading: false,
            isResizing: false,
            startX: 0,
            startWidth: 0,
            playPath: '',
            rawLyrics: '',
            showVersionHistory: false,
            versionTrackInfo: null,
        }
    },
    computed: {
        ...mapGetters(['geFullPath', 'sortedField', 'searchWord']),
        ...mapState({
            homeAction: state => state.common.homeAction,
            homeActionTimestamp: state => state.common.homeActionTimestamp
        }),
        filePath: {
            get() {
                return this.geFullPath
            },
            set(value) {
                this.$store.commit('setFullPath', value)
            }
        },
        checkedIds: {
            get() {
                return this.$store.state.common.checkedIds
            },
            set(value) {
                this.$store.commit('setCheckedIds', value)
            }
        },
        checkedData: {
            get() {
                return this.$store.state.common.checkedData
            },
            set(value) {
                this.$store.commit('setCheckedData', value)
            }
        },
        filesNumber: {
            get() {
                return this.checkedData.filter(item => ['icon-script-file', 'icon-script-files', 'icon-strm', 'icon-cue'].indexOf(item.icon) !== -1).length
            }
        },
        folderNumber: {
            get() {
                return this.checkedData.filter(item => item.icon === 'icon-folder').length
            }
        },
        isHiddenBGP: {
            get() {
                return window.localStorage.getItem('isHiddenBGP') === 'true'
            },
            set(value) {
                window.localStorage.setItem('isHiddenBGP', value ? 'true' : 'false')
            }
        }
    },
    watch: {
        homeActionTimestamp(newTimestamp, oldTimestamp) {
            // 当时间戳变化时，执行对应的操作
            if (newTimestamp > oldTimestamp && this.homeAction) {
                this.handleHomeAction(this.homeAction)
            }
        }
    },
    created() {
    },
    mounted() {
        document.addEventListener('mousemove', this.handleResize)
        document.addEventListener('mouseup', this.stopResize)
        // 调试：检查是否正确访问了 store 状态
        console.log('home mounted, homeAction:', this.homeAction, 'homeActionTimestamp:', this.homeActionTimestamp)
        console.log('store state:', this.$store.state)
    },
    beforeDestroy() {
        document.removeEventListener('mousemove', this.handleResize)
        document.removeEventListener('mouseup', this.stopResize)
    },
    methods: {
        // 点击树的节点后展示详情
        showEditPage(parentPath, nodeName) {
            this.isShowEdit = true
            this.showId3List = this.checkedIds.length > 0
            this.musicInfo = this.baseMusicInfo
            this.fileName = nodeName
            this.section2Loading = true
            this.$api.Task.musicId3({ 'file_path': parentPath, 'file_name': nodeName }).then((res) => {
                if (res.result) {
                    this.section2Loading = false
                    this.musicInfo = res.data
                    this.isSaveLyricsFile = false
                    this.isImportLyricsFile = false
                    this.isSaveAlbumCover = false
                    this.genreInputList = this.musicInfo.genre ? [this.musicInfo.genre] : []
                    this.languageInputList = this.musicInfo.language ? [this.musicInfo.language] : []
                    this.albumArtistInputList = this.musicInfo.albumartist ? [this.musicInfo.albumartist] : []
                    this.albumArtistList = this.parseAlbumArtistList(this.musicInfo.artist)
                    this.musicInfo.files1 = [
                        {
                            name: 'cover.png',
                            status: 'done',
                            url: this.musicInfo.artwork
                        }
                    ]
                } else {
                    this.$myMsg.notify({
                        title: '修改失败！',
                        content: res.message,
                        type: 'error',
                        time: 5000,
                    })
                }
            })
        },
        showEditPageDrawer(parentPath, nodeName) {
            this.isShowEdit = false
            // this.showId3List = this.checkedIds.length > 0
            this.musicInfo = this.baseMusicInfo
            this.fileName = nodeName
            this.section2Loading = true
            this.isShowEdit2 = true
            this.$api.Task.musicId3({ 'file_path': parentPath, 'file_name': nodeName }).then((res) => {
                if (res.result) {
                    this.section2Loading = false
                    this.musicInfo = res.data
                    this.isSaveLyricsFile = false
                    this.isImportLyricsFile = false
                    this.isSaveAlbumCover = false
                    this.genreInputList = this.musicInfo.genre ? [this.musicInfo.genre] : []
                    this.languageInputList = this.musicInfo.language ? [this.musicInfo.language] : []
                    this.albumArtistInputList = this.musicInfo.albumartist ? [this.musicInfo.albumartist] : []
                    this.albumArtistList = this.parseAlbumArtistList(this.musicInfo.artist)
                    this.musicInfo.files1 = [
                        {
                            name: 'cover.png',
                            status: 'done',
                            url: this.musicInfo.artwork
                        }
                    ]
                } else {
                    this.$myMsg.notify({
                        title: '修改失败！',
                        content: res.message,
                        type: 'error',
                        time: 5000,
                    })
                }
            })
        },

        // 处理专辑艺术家
        parseAlbumArtistList(artists) {
            let ret = []
            if (artists) {
                let artistArray = []
                if (artists.indexOf(',') > -1) {
                    artistArray = artists.split(',')
                } else if (artists.indexOf('/') > -1) {
                    artistArray = artists.split('/')
                } else if (artists.indexOf('&') > -1) {
                    artistArray = artists.split('&')
                } else if (artists.indexOf('、') > -1) {
                    artistArray = artists.split('、')
                } else if (artists.indexOf('，') > -1) {
                    artistArray = artists.split('，')
                } else {
                    artistArray = []
                }
                artistArray.push(artists)
                ret = artistArray.map((item) => {
                    return {
                        'id': item,
                        'name': item
                    }
                })
            }
            return ret
        },
        handleCopy(k, v, callback) {
            if (k === 'lyric') {
                this.resource = localStorage.getItem('resource') ? localStorage.getItem('resource') : 'netease'
                const resurce = this.resource !== 'smart_tag' ? this.resource : v.resource
                this.$api.Task.fetchLyric({ 'song_id': v.id, 'resource': resurce }).then((res) => {
                    if (res.result) {
                        if (res.data !== '') {
                            this.musicInfo['lyrics'] = res.data
                            this.handleCopy('composer', this.musicInfo['lyrics'])
                        } else {
                            this.$myMsg.notify({
                                title: '未找到歌词！',
                                type: 'error',
                                time: 2000,
                            })
                        }
                    } else {
                        this.$myMsg.notify({
                            title: '未找到歌词！',
                            type: 'error',
                            time: 2000,
                        })
                    }
                }).finally(() => {
                    if (callback && typeof callback === 'function') {
                        callback()
                    }
                })
            } else if (k === 'composer') {
                this.$api.Task.extractLyric({ 'lyc': v }).then((res) => {
                    if (res.result) {
                        if (res.data !== '') {
                            this.musicInfo['composer'] = res.data.composer
                            this.musicInfo['lyricist'] = res.data.lyricist
                        } else {
                            console.log()
                        }
                    } else {
                        console.log()
                    }
                })
            }
            else if (k === 'album_img') {
                this.musicInfo[k] = ''
                this.musicInfo['artwork'] = v
                this.musicInfo['files1'] = [
                    {
                        name: 'new.png',
                        status: 'done',
                        url: v
                    }
                ]
                this.reloadImg = false
                this.$nextTick(() => {
                    this.reloadImg = true
                })
            } else if (k === 'lyric_tran') {
                this.musicInfo['lyrics'] = v
            } else if (k === 'artist') {
                // 按照ARTIST_SPLIT_DELIMITERS分割artist字符串
                if (typeof v === 'string') {
                    // 定义分隔符数组
                    const delimiters = [",", "\\", "&", "+", "|", "、", "，", ";", "ft.", "feat.", "Feat.","\u0000","\x00"];
                    // 构造正则表达式
                    const regex = new RegExp(delimiters.map(d => d.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')).join('|'), 'g');
                    // 分割并去除首尾空格，过滤空字符串
                    this.musicInfo['artist_list'] = v.split(regex).map(s => s.trim()).filter(s => s);
                } else {
                    this.musicInfo['artist_list'] = v
                }
                this.musicInfo[k] = v
            }
            else {
                this.musicInfo[k] = v
            }
        },
        copyAll(item) {
            this.handleCopy('title', item.name)
            this.handleCopy('year', item.year)
            this.handleCopy('lyric', item)
            this.handleCopy('album', item.album)
            this.handleCopy('artist', item.artist)
            this.handleCopy('album_img', item.album_img)
            this.handleCopy('tracknumber', item.tracknumber)
            this.handleCopy('discnumber', item.discnumber)
            this.handleCopy('totaltracks', item.totaltracks)
            this.handleCopy('totaldiscs', item.totaldiscs)
        },
        nodeExpandedOne(node, expanded) {
            console.log(node, expanded)
        },
        handleSearchFile() {
            this.$refs['file-tree'].handleSearchFile()
        },
        // 单个保存音乐信息
        handleClick() {
            // 刷新目录
            if (this.fileName !== this.musicInfo.filename) {
                this.fileName = this.musicInfo.filename
                this.handleSearchFile()
            }
        },
        fetchFileID3FolderList(mode, refresh = false) {
            const path = require('path')
            const fileName = path.basename(this.filePath)
            const directoryName = path.dirname(this.filePath);
            const batchSettingFormData = {
                'isOpenDetail': localStorage.getItem('isOpenDetail') !== 'false',
                'isDepth': localStorage.getItem('isDepth') === 'true',
                'isOpenWebdav': localStorage.getItem('isOpenWebdav') === 'true',
                'isDepthWebdav': localStorage.getItem('isDepthWebdav') === 'true',
                'limit': localStorage.getItem('limit') ? localStorage.getItem('limit') : 100
            }
            if (!batchSettingFormData.isOpenDetail) {
                return
            }
            if (this.filePath.startsWith('/app/webdav/') && !batchSettingFormData.isOpenWebdav) {
                return
            }
            if (this.filePath.startsWith('/Users/macbookair/Music/my_music/music/music_lyc/webdav') && !batchSettingFormData.isOpenWebdav) {
                return
            }
            let depth = 1
            if (batchSettingFormData.isDepth) {
                depth = -1
            }
            this.showTranslation = false
            this.fadeShowDetail = false
            if (this.checkedIds.length === 0 && this.fileID3List.length !== 0) {
                this.fileID3List = []
            }
            // 重置分页状态
            this.currentPage = 1
            this.hasMoreData = false
            this.showId3ListLoading = true

            // 保存请求参数以便加载更多时使用
            this.lastRequestParams = {
                'file_full_path': directoryName,
                'select_data': [{
                    'icon': 'icon-folder',
                    'name': fileName,
                    'title': fileName,
                }],
                'mode': 'all',
                'limit': batchSettingFormData.limit,
                'depth': depth,
                'sorted_fields': this.sortedField,
                'search_word': this.searchWord,
                'refresh': refresh
            }

            this.$api.Task.fileID3List({
                ...this.lastRequestParams,
                'page': this.currentPage,
                'page_size': this.pageSize
            }).then((res) => {
                console.log(1111)
                if (res.result) {
                    this.showId3ListLoading = false
                    // 适配新的分页数据格式
                    const responseData = res.data
                    console.log(this.hasMoreData)

                    this.hasMoreData = responseData.has_more
                    if (responseData.list && responseData.list.length > 0) {
                        this.fileID3List = responseData.list
                        this.totalCount = responseData.total
                        this.showId3List = true
                    } else if (Array.isArray(res.data) && res.data.length > 0) {
                        // 兼容旧格式
                        this.fileID3List = res.data
                        this.showId3List = true
                    }
                } else {
                    if (res.message.status === 401) {
                        return
                    }
                    this.$myMsg.notify({
                        title: '查询失败',
                        content: res.message,
                        type: 'error',
                        time: 2000,
                    })
                }
            })
        },
        removeFileID3List(id) {
            this.fileID3List = this.fileID3List.filter((item) => item.id !== id)
        },
        deleteFileID3List() {
            this.fileID3List = []
            this.currentPage = 1
            this.hasMoreData = false
        },
        // 处理触底加载更多
        handleLoadMore() {
            if (this.isLoadingMore || !this.hasMoreData || !this.lastRequestParams) {
                return
            }

            this.isLoadingMore = true
            this.currentPage += 1

            this.$api.Task.fileID3List({
                ...this.lastRequestParams,
                'page': this.currentPage,
                'page_size': this.pageSize
            }).then((res) => {
                if (res.result) {
                    const responseData = res.data
                    this.hasMoreData = responseData.has_more
                    console.log(222, this.hasMoreData)
                    if (responseData.list && responseData.list.length > 0) {
                        // 追加数据而不是替换
                        this.fileID3List = [...this.fileID3List, ...responseData.list]
                        this.totalCount = responseData.total
                    } else if (Array.isArray(res.data) && res.data.length > 0) {
                        // 兼容旧格式
                        this.fileID3List = [...this.fileID3List, ...res.data]
                    }
                } else {
                    this.$myMsg.notify({
                        title: '加载失败',
                        message: res.message,
                        type: 'error'
                    })
                }
            }).catch((err) => {
                console.error('加载更多失败:', err)
                this.$myMsg.notify({
                    title: '加载失败',
                    message: '网络错误',
                    type: 'error'
                })
            }).finally(() => {
                this.isLoadingMore = false
            })
        },
        // 处理每页显示数量变化
        handlePageSizeChange(newPageSize) {
            this.pageSize = newPageSize
            localStorage.setItem('pageSize', newPageSize)
            // 重新加载第一页数据
            if (this.lastRequestParams) {
                this.currentPage = 1
                this.showId3ListLoading = true

                this.$api.Task.fileID3List({
                    ...this.lastRequestParams,
                    'page': 1,
                    'page_size': newPageSize
                }).then((res) => {
                    if (res.result) {
                        this.showId3ListLoading = false
                        const responseData = res.data
                        this.hasMoreData = responseData.has_more
                        if (responseData.list && responseData.list.length > 0) {
                            this.fileID3List = responseData.list
                            this.totalCount = responseData.total
                        } else if (Array.isArray(res.data) && res.data.length > 0) {
                            this.fileID3List = res.data
                        }
                    } else {
                        this.showId3ListLoading = false
                        this.$myMsg.notify({
                            title: '加载失败',
                            message: res.message,
                            type: 'error'
                        })
                    }
                }).catch((err) => {
                    console.error('切换每页数量失败:', err)
                    this.showId3ListLoading = false
                })
            }
        },
        toggleLock(mode) {
            if (!this.musicInfo.title) {
                this.$myMsg.notify({
                    title: '标题不能为空！',
                    type: 'error',
                    time: 2000,
                })
                return
            }
            console.log(mode)
            if (mode === 'page') {
                this.showTranslation = false
                this.isShowResourceId3 = false
                this.fadeShowDetail = true
            } else {
                this.showTranslation = false
                this.fadeShowDetail = false
                this.isShowResourceId3 = true
            }
            if (this.filePath.endsWith('/')) {
                this.fullPath = this.filePath + this.fileName
            } else {
                this.fullPath = this.filePath + '/' + this.fileName
            }
            this.section3Loading = true
            this.$api.Task.fetchId3Title({
                title: this.musicInfo.title,
                artist: this.musicInfo.artist,
                album: this.musicInfo.album,
                full_path: this.fullPath,
                resource: localStorage.getItem('resource') ? localStorage.getItem('resource') : 'netease'
            }).then((res) => {
                this.SongList = res.data
                this.section3Loading = false
            })
        },
        // 打开单个编辑抽屉
        handleEdit2(item) {
            console.log('open', item)
            this.musicInfo = item
            this.isSaveLyricsFile = false
            this.isImportLyricsFile = false
            this.isSaveAlbumCover = false
            this.genreInputList = this.musicInfo.genre ? [this.musicInfo.genre] : []
            this.languageInputList = this.musicInfo.language ? [this.musicInfo.language] : []
            this.albumArtistInputList = this.musicInfo.albumartist ? [this.musicInfo.albumartist] : []
            this.albumArtistList = this.parseAlbumArtistList(this.musicInfo.artist)
            this.musicInfo.files1 = [
                {
                    name: 'cover.png',
                    status: 'done',
                    url: this.musicInfo.artwork
                }
            ]
            this.fileName = this.musicInfo.filename
            this.isShowEdit2 = true
        },
        translation() {
            if (!this.musicInfo.lyrics) {
                this.$myMsg.notify({
                    title: '歌词不能为空！',
                    type: 'error',
                    time: 2000,
                })
            }
            this.fadeShowDetail = false
            this.isShowResourceId3 = false
            this.showTranslation = true
            this.$api.Task.translationLyc({
                lyc: this.musicInfo.lyrics
            }).then((res) => {
                this.showTranslation = true
                this.translationText = res.data
            })
        },
        showFileSection() {
            this.$refs['file-section'].style.setProperty('display', 'block', 'important')
            this.$refs['edit-section'].style.display = 'none'
            this.$refs['resource-section'].style.display = 'none'
        },
        showEditSection() {
            this.$refs['edit-section'].style.setProperty('display', 'block', 'important')
            this.$refs['file-section'].style.setProperty('display', 'none', 'important')
            this.$refs['resource-section'].style.display = 'none'
        },
        showResourceSection() {
            this.$refs['file-section'].style.display = 'none'
            this.$refs['edit-section'].style.display = 'none'
            this.$refs['resource-section'].style.setProperty('display', 'block', 'important')
        },
        startResize(e) {
            this.isResizing = true
            this.startX = e.clientX
            this.startWidth = this.$refs['file-section'].offsetWidth
        },
        handleResize(e) {
            if (!this.isResizing) return

            const width = this.startWidth + (e.clientX - this.startX)
            // 设置最小和最大宽度限制
            if (width >= 200 && width <= window.innerWidth * 0.8) {
                this.$refs['file-section'].style.width = `${width}px`
            }
        },
        stopResize() {
            this.isResizing = false
        },
        showLyricsTimelineModal(playPath, lyrics) {
            this.showLyricsTimeline = true
            this.playPath = playPath
            this.rawLyrics = lyrics
        },
        handleSaveLyrics(lyrics) {
            this.musicInfo.lyrics = lyrics
        },
        // 处理移动端导航栏的操作事件
        handleHomeAction(actionName) {
            if (this[actionName] && typeof this[actionName] === 'function') {
                this[actionName]()
            }
        },
        // 处理显示版本历史
        handleShowVersionHistory(trackInfo) {
            this.versionTrackInfo = trackInfo
            this.showVersionHistory = true

            // 等待抽屉打开后再加载版本历史
            this.$nextTick(() => {
                if (this.$refs.versionHistoryComponent) {
                    this.$refs.versionHistoryComponent.open(
                        trackInfo.id,
                        trackInfo.title,
                        trackInfo.path
                    )
                }
            })
        },
        // 处理版本回退成功
        handleVersionRestored(version) {
            this.$myMsg.notify({
                title: '版本回退成功',
                content: `已回退到版本 v${version.version_number}`,
                type: 'success',
                time: 2000,
            })

            // 关闭抽屉
            this.showVersionHistory = false

            // 刷新当前页面数据
            this.handleClick()
        }
    }
}
</script>
<style lang="postcss">
.music-item {
    cursor: pointer;
}

.music-item:hover {
    color: #1facdd;
}

.label1 {
    width: 80px;
}

.parent {
    display: grid;
    grid-template-columns: repeat(7, 1fr);
    grid-template-rows: repeat(1, 1fr);
    grid-column-gap: 0;
    grid-row-gap: 0;
    place-items: center;
    margin-bottom: 15px;
}

.title2 {
    font-weight: 500;
}

.song-card {
    display: flex;
    align-items: center;
    border-bottom: 1px solid #E2E2E2;
}

.song-card:hover {
    background: #E2E2E2;
}

.add-button {
    width: 24px;
    height: 24px;
    line-height: 20px;
    display: inline-block;
    background-color: transparent;
    border: 1px solid #ccc;
    border-radius: 5px;
    margin-left: 5px;
    font-size: 12px;
    color: rgb(97, 97, 97);
    text-align: center;
    cursor: pointer;
}

.delete-button {
    width: 24px;
    height: 24px;
    line-height: 20px;
    display: inline-block;
    background-color: transparent;
    border: 1px solid #ccc;
    border-radius: 5px;
    margin-left: 5px;
    font-size: 12px;
    color: rgb(63, 63, 63);
    text-align: center;
    cursor: pointer;
}

@media (max-width: 430px) {

    /* 在屏幕宽度小于400像素时应用的CSS规则 */
    .file-section {
        height: calc(100vh - 70px);
        overflow: scroll;
        width: 300px;
        /* 设置初始宽度 */
    }

    .edit-section {
        height: calc(100vh - 70px);
        overflow: scroll;
        width: 100vh;
        /*border: 1px solid #173769;*/
        /*border-radius: 20px;*/
    }

    .resource-section {
        height: calc(100vh - 70px);
        width: 100vh;
        flex: 1;
        overflow: scroll;
        /*border: 1px solid #173769;*/
        /*border-radius: 20px;*/
    }
}

@media (min-width: 430px) {

    /* 在屏幕宽度大于400像素时应用的CSS规则 */
    .file-section {
        height: calc(100vh - 90px);
        overflow: scroll;
        width: 300px;
        /* 设置初始宽度 */
        margin: 10px 0 10px 10px;
    }

    .edit-section {
        height: calc(100vh - 90px);
        overflow: scroll;
        /*border: 1px solid #173769;*/
        margin: 10px 10px 10px 10px;
        /*border-radius: 20px;*/
    }

    .resource-section {
        height: calc(100vh - 90px);
        min-width: 400px;
        flex: 1;
        overflow: scroll;
        /*border: 1px solid #173769;*/
        margin: 10px 10px 10px 0;
        /*border-radius: 20px;*/
    }
}


/*.success {*/
/*    color: #d1cfc5;*/
/*}*/

.failed {
    color: #ac354b;
}

.null {
    color: #333146;
}


::-webkit-scrollbar {
    width: 0;
    background-color: transparent;
}

::-webkit-scrollbar-thumb {
    background-color: #f4f5f0;
}

.file-section:hover::-webkit-scrollbar {
    width: 6px;
}

.isSelected {
    background-color: #ecf3fe;
}

.edit-item {
    display: flex;
    margin-bottom: 10px;
    align-items: center;
}

.can-copy {
    cursor: pointer;
}

.resize-handle {
    width: 4px;
    background-color: transparent;
    cursor: col-resize;
    transition: background-color 0.2s;
    margin: 10px 0;
    position: relative;
}

.resize-handle::after {
    content: '';
    position: absolute;
    top: 0;
    left: -3px;
    width: 10px;
    height: 100%;
    background-color: transparent;
}

.resize-handle:hover {
    background-color: #eff1f3;
}

/* 确保拖动时拖动条保持显示 */
.resize-handle.resizing,
.resize-handle:hover {
    background-color: #eff1f3;
}

/* 在移动端隐藏拖拽手柄 */
@media (max-width: 768px) {
    .resize-handle {
        display: none;
    }
}
</style>
